import { Constant } from '../../services/services';
import { CommonService as commonService } from '../../services/commonService';
import { useGlobalState } from '../../services/state';
import { BookingData, Customer } from '../../models/appModels';
import { cloneDeep } from 'lodash';

const useSetupBooking = () => {
	const [, setAppointmentDetailData] = useGlobalState('appointmentDetailData');
	const [, setServiceDetailData] = useGlobalState('serviceDetailData');
	const [, setJobLineData] = useGlobalState('jobLineData');
	const [, setCustomerDetailData] = useGlobalState('customerDetailData');
	const [, setVehicleDetailData] = useGlobalState('vehicleDetailData');
	const [, setOriginalVehicleMake] = useGlobalState('originalVehicleMake');
	const [, setBookingData] = useGlobalState('bookingData');
	const [, setOwnedVehiclesData] = useGlobalState('ownedVehiclesData');
	const [, setBookingSearchData] = useGlobalState('bookingSearchData');
	const [dealershipId, setDealershipId] = useGlobalState('dealershipId');
	const [makeList] = useGlobalState('makeList');
	const [customerType] = useGlobalState('customerType');

	const setupGlobalData = (
		dataInput: BookingData,
		customerSearchInfo: {
			mobileNumber: any;
			email: any;
			cardRegistration: string;
		}
	) => {
		const data = cloneDeep(dataInput);
		if (data.Booking.Appointment) {
			if (data.Booking.Appointment.DropOffTime) {
				data.Booking.Appointment.BookingDate = data.Booking.Appointment.DropOffTime;
				data.Booking.Appointment.DropOffTime = new Date(data.Booking.Appointment.DropOffTime);
			}
			if (data.Booking.Appointment.PickUpTime) {
				data.Booking.Appointment.PickUpTime = new Date(data.Booking.Appointment.PickUpTime);
			}
			data.Booking.Appointment.Note = data.Booking.CustomerComment;
			setAppointmentDetailData(data.Booking.Appointment);
			if (data.Booking.Appointment.Location) {
				setServiceDetailData({
					location: data.Booking.Appointment.Location,
					serviceAdvisor: data.Booking.ServiceAdvisor,
				});
				if (!dealershipId) {
					setDealershipId(data.Booking.Appointment.Location.DealershipId);
				}
			}
		}
		if (data.Booking.Jobs) setJobLineData(data.Booking.Jobs);
		if (data.Booking.Customer) {
			data.Booking.Customer.CustomerType = customerType
				? customerType
				: Constant.customerTypes.Person;
			setCustomerDetailData(data.Booking.Customer);
		} else {
			if (customerType === Constant.customerTypes.Organization) {
				let obj = {
					CustomerType: customerType,
					Mobile: customerSearchInfo.mobileNumber,
					ContactCustomer: { Email: customerSearchInfo.email },
				};
				setCustomerDetailData(obj as Customer);
			} else {
				setCustomerDetailData({
					Mobile: customerSearchInfo.mobileNumber,
					Email: customerSearchInfo.email,
					CustomerType: customerType,
				} as Customer);
			}
		}
		if (data.Booking.Vehicle) {
			if (
				data.Booking.Customer &&
				((data.Booking.Customer.Id > 0 &&
					data.Booking.Vehicle.OwnerCustomerId > 0 &&
					data.Booking.Customer.Id == data.Booking.Vehicle.OwnerCustomerId) ||
					(data.Booking.Vehicle.OwnerCustomer &&
						data.Booking.Customer.DmsCustomerKey > 0 &&
						data.Booking.Vehicle.OwnerCustomer.DmsCustomerKey > 0 &&
						data.Booking.Customer.DmsCustomerKey ==
							data.Booking.Vehicle.OwnerCustomer.DmsCustomerKey))
			) {
				data.Booking.Vehicle.IsCarOwner = true;
			}
			setVehicleDetailData(data.Booking.Vehicle);
			setOriginalVehicleMake(data.Booking.Vehicle.MakeId);
			setBookingSearchData({});
		} else {
			if (customerSearchInfo.cardRegistration) {
				const bookingLookupType = process.env.REACT_APP_BOOKING_LOOKUP || "";
				const allowVinType = [Constant.bookingLookup.ALL, Constant.bookingLookup.VIN].includes(bookingLookupType);
				const isVin = customerSearchInfo.cardRegistration.length === Constant.requiredVinLength;
				setBookingSearchData({
					IsVin: allowVinType && isVin,
					CardRegistration: customerSearchInfo.cardRegistration,
				});
			}
		}
		if (data.Booking.OwnedVehicles) {
			let ownedVehicles = data.Booking.OwnedVehicles.filter((v) =>
				commonService.validateVehicleMake(v, makeList)
			);
			setOwnedVehiclesData(ownedVehicles);
		}
		setBookingData(data);
	};

	return [setupGlobalData];
};

export default useSetupBooking;
